import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ContentWrapper from "./ContentWrapper";
import Block from "./Block";
import Column from "./Column";

const propTypes = {
    image: PropTypes.shape({
        url: ""
    }).isRequired,
    text: PropTypes.string,
    alignment: PropTypes.string
};

const defaultProps = {
    alignment: "bottom",
    text: ""
};

export default function JumboTron({ alignment, image, text }) {
    const textClasses = classnames({
        "text-white  font-header  text-5xl  font-bold md:text-5xl  lg:text-6xl  leading-cold-water": true,
        "self-center": alignment === "center",
        "self-end  mb-24": alignment === "bottom",
        "self-start mt-4 lg:mt-24": alignment === "top"
    });

    return (
        <div
            className="w-full  bg-cover  bg-center  min-h-25  lg:min-h-40  xxl:min-h-50  relative"
            style={{ backgroundImage: `url(${image.url})` }}
        >
            <ContentWrapper>
                <Block>
                    <Column className={textClasses}>
                        <div className="pt-24  lg:pt-0">{text}</div>
                    </Column>
                </Block>
            </ContentWrapper>
        </div>
    );
}

JumboTron.propTypes = propTypes;
JumboTron.defaultProps = defaultProps;
